import React from "react";

/**
 * Tilde de la fila de acciones. Era un glyph relleno en una grilla de 20 y
 * pesaba el doble que sus vecinos: ahora es de la misma familia que el resto
 * (grilla de 24, trazo de 2, `currentColor`).
 */
export default function CheckIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      height={props.height}
      width={props.width}
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ ...props.style, cursor: "pointer" }}
      {...props}
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}

CheckIcon.defaultProps = {
  height: `2.2rem`,
  width: `2.2rem`,
  color: "currentColor",
};
